import { actions as notifActions } from "redux-notifications";
const { notifSend } = notifActions;

//common shared action between componenets
export const loadMorePosts = ({ override = false, limit = 5, pagingToken, appliedFilters }) => ({
  type: "LOAD_MORE_POSTS_REQUEST",
  limit,
  override,
  pagingToken,
  appliedFilters,
});

export const loadMorePostsSuccess = ({ override, limit, posts, pagingToken }) => ({
  type: "LOAD_MORE_POSTS_SUCCESS",
  posts,
  limit,
  override,
  pagingToken,
});

export const loadMorePostsFailed = error => ({
  type: "LOAD_MORE_POSTS_FAILED",
  error,
});

export const showPostModal = post => {
  return {
    type: "SHOW_POST_MODAL",
    post,
  };
};

export const hidePostModal = () => {
  return {
    type: "HIDE_POST_MODAL",
  };
};

export const showUserSignInModal = message => {
  return {
    type: "SHOW_USER_SIGN_IN_MODAL",
    message,
  };
};

export const hideUserSignInModal = () => {
  return {
    type: "HIDE_USER_SIGN_IN_MODAL",
  };
};

export const showConfirmDialog = options => {
  return {
    type: "SHOW_CONFIRM_DIALOG",
    options: { ...options },
  };
};

export const hideConfirmDialog = _ => {
  return {
    type: "HIDE_CONFIRM_DIALOG",
  };
};

export const showAlert = (message, alertType = "success", dismissAfter = 3000) =>
  notifSend({
    message,
    kind: alertType,
    dismissAfter,
  });

export const showNotificationAlert = notificationData =>
  notifSend({
    kind: "notification",
    dismissAfter: 3000,
    ...notificationData,
  });

export const setPostCategoryFilter = categoryId => ({
  type: "SET_POST_CATEGORY_FILTER",
  categoryId,
});

export const applyPostCategoryFilter = categoryId => ({
  type: "APPLY_POST_CATEGORY_FILTER",
  categoryId,
});

export const clearPostCategoryFilter = () => ({
  type: "CLEAR_POST_CATEGORY_FILTER",
});

export const clearPosts = () => ({
  type: "CLEAR_POSTS",
});

export const showDownloadAppDialog = () => ({
  type: "SHOW_DOWNLOAD_APP_DIALOG",
});

export const hideDownloadAppDialog = () => ({
  type: "HIDE_DOWNLOAD_APP_DIALOG",
});

export const ratePost = ({ postId, rating }) => ({
  type: "RATE_POST_REQUEST",
  postId,
  rating,
});

export const ratePostSuccess = postId => ({
  type: "RATE_POST_SUCCESS",
  postId,
});

export const ratePostFailed = postId => ({
  type: "RATE_POST_FAILED",
  postId,
});



// WEBPACK FOOTER //
// ./src/actions/index.js